module.exports = __webpack_public_path__ + "img/benefit_travel.c7390f7f.svg";